import { Report } from "pmt-types/src/models/Report.ts";
import { useMutation } from "react-query";
import { useAuthentication } from "../useAuthentication.ts";

export const useMutationGenerateReportLink = () => {
  const { accessToken } = useAuthentication();

  return useMutation(
    async (report: Report) => {
      const response = await fetch(
        `${import.meta.env.VITE_API_HOST}/reports/${report.id}/link`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: accessToken ?? "",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to generate report link");
      }

      return (await response.json()) as { url: string };
    },
    {
      onError: (error, data) => {
        console.error("Failed to generate report link", error, data);
      },
    },
  );
};
